module.exports = __webpack_public_path__ + "img/farizon.7f2a6fb0.jpg";